import axiosNew from '../../helpers/axios'

/** In-app notifications (support API). */
export const listSupportNotifications = ({
    skip = 0,
    limit = 20,
    unRead,
} = {}) => {
    const params = { skip, limit }
    if (unRead) {
        params.unRead = true
    }
    return axiosNew({
        url: 'support/notifications',
        method: 'GET',
        params,
    })
}

/** Mark a single notification as read (top-level notification `_id`). */
export const putSupportNotificationRead = (id) =>
    axiosNew({
        url: `support/notifications/${encodeURIComponent(String(id))}/read`,
        method: 'PUT',
    })

/** Mark all notifications as read for the current user. */
export const putSupportNotificationsReadAll = () =>
    axiosNew({
        url: 'support/notifications/read-all',
        method: 'PUT',
    })

// GET NOTIFICATIONS LIST
export const getNotifications = (payload) => {
    const { userId, unRead } = payload

    return new Promise(async (resolve) => {
        try {
            const getNotification = await axiosNew({
                url: `notifications/list?userId=${userId}${
                    unRead ? `&unRead=${unRead}` : ''
                }`,
                method: 'get',
            })
            resolve({ data: getNotification?.data ?? [] })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// UNREAD NOTIFICATIONS
export const changeStatusNotification = (payload) => {
    const { notificationId } = payload

    let data = payload?.notificationClick ?? {}

    return new Promise(async (resolve) => {
        try {
            const changeStatus = await axiosNew({
                url: `notifications/change-status/${notificationId}`,
                method: 'put',
                data,
            })
            resolve({ data: changeStatus?.data ?? [] })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// MARK ALL AS READ NOTIFICATIONS
export const getMarkAsRead = (payload) => {
    const { userId } = payload

    return new Promise(async (resolve) => {
        try {
            const getMarkAsRead = await axiosNew({
                url: `notifications/mark-all-read/${userId}`,
                method: 'put',
            })
            resolve({ data: getMarkAsRead?.data ?? [] })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}
